import { Money, PaymentStatus, PaymentType } from "../http/protocol";
import { t } from "../i18n";



export const getStatus = (status: PaymentStatus): { classname: string, translation: string } => {
    const statusInfo: Record<PaymentStatus, { classname: string, translation: string }> = {
        [PaymentStatus.COMPLETED]: { classname: 'status-completed', translation: t('transactions.status.completed') },
        [PaymentStatus.FAILED]: { classname: 'status-failed', translation: t('transactions.status.failed') },
        [PaymentStatus.FAILED_PERMANENTLY]: { classname: 'status-failed-permanent', translation: t('transactions.status.failed_permanently') },
        [PaymentStatus.CANCELED]: { classname: 'status-cancelled', translation: t('transactions.status.canceled') },
        [PaymentStatus.DECLINED]: { classname: 'status-declined', translation: t('transactions.status.declined') },
        [PaymentStatus.PENDING]: { classname: 'status-pending', translation: t('transactions.status.pending') },
        [PaymentStatus.INITIATED]: { classname: 'status-initiated', translation: t('transactions.status.initiated') },
        [PaymentStatus.RESOLVED]: { classname: 'status-resolved', translation: t('transactions.status.resolved') },
        [PaymentStatus.PLACEHOLDER]: { classname: 'status-placeholder', translation: t('transactions.status.placeholder') },
        [PaymentStatus.APPLIED_WAITING_TO_CLEAR]: { classname: 'status-applied-waiting', translation: t('transactions.status.applied_waiting_to_clear') }
    };

    return statusInfo[status] || { classname: 'default-status', name: '' };
};


export const getTypeIcon = (type: PaymentType): 'withdraw' | 'deposit' => {
    const iconMap: Record<any, any> = {
        [PaymentType.WITHDRAWAL]: 'withdraw',
        [PaymentType.DEPOSIT]: 'deposit'
    };

    return iconMap[type as keyof typeof iconMap] || null;
};

export const getTypeTranslation = (type: PaymentType): string => {
    const iconMap: Record<Exclude<PaymentType, PaymentType.AUTH | PaymentType.CORRECTION | PaymentType.BONUS>, string> = {
        [PaymentType.WITHDRAWAL]: t("transactions.types.withdraw"),
        [PaymentType.DEPOSIT]: t("transactions.types.deposit")
    };

    return iconMap[type as keyof typeof iconMap] || 'N/A';
};


export const getCasinoType = (type?: string, amount?: Money) => {
    if (!type) {
        return "";
    }

    let winLoss = 0;
    if (amount && amount.amount) {
        if (amount.amount > 0) {
            winLoss = 1;
        } else if (amount.amount < 0) {
            winLoss = -1;
        }
    }

    if (type == "STANDARD_BET") {
        return t("transactions.types.bet");
    } else if (type == "STANDARD_WIN" || (type == "BET_WIN" && winLoss > 0)) {
        return t("transactions.types.win");
    } else if (type == "STANDARD_WIN" || (type == "BET_WIN" && winLoss > 0)) {
        return t("transactions.types.loss");
    }
    return "";
}


export const getPokerType = (type?: string) => {
    if (type == "CASH_GAME_BUY_IN") {
        return t("transactions.types.buy-in");;
    } else if (type == "CASH_GAME_PAYOUT") {
        return t("transactions.types.payout");
    } else if (type == "TOURNAMENT_PAYOUT") {
        return t("transactions.types.tournament-payout");
    } else if (type == "TOURNAMENT_BUY_IN") {
        return t("transactions.types.tournament-buy-in");
    } else if (type == "POKER_BONUS_PAYOUT") {
        return t("transactions.types.cash-bonus");
    } else if (type == "TOURNAMENT_UNREGISTER") {
        return t("transactions.types.tournament-unregister");
    } else if (type == "POKER_PRODUCT_PURCHASE") {
        return t("transactions.types.purchase");
    } else {
        return "N/A";
    }
}
/* POKER_BONUS_PAYOUT, TOURNAMENT_UNREGISTER */

export const getSportsbookType = (type?: string, amount?: Money) => {
    if (!type) {
        return "";
    }
    let winLoss = 0;
    if (amount !== undefined && amount.amount !== undefined) {
        if (amount.amount > 0) {
            winLoss = 1;
        } else if (amount.amount < 0) {
            winLoss = -1;
        }
    }

    if (type == "SPORTSBOOK_BET") {
        return t("transactions.types.sb-bet");
    } else if (type == "SPORTSBOOK_SETTLEMENT" && winLoss > 0) {
        return t("transactions.types.sb-win");
    } else if (type == "SPORTSBOOK_SETTLEMENT" && winLoss <= 0) {
        return t("transactions.types.loss");
    } else if (type == "SPORTSBOOK_CANCELLATION") {
        return t("transactions.types.sb-refund");
    } else if (type == "SPORTSBOOK_UNSETTLEMENT") {
        return t("transactions.types.sb-result-reversed");
    } else if (type == "SPORTSBOOK_DECLINED") {
        return t("transactions.types.sb-refund");
    } else if (type == "SPORTSBOOK_REFUND") {
        return t("transactions.types.sb-refund");
    }

    return "";
}



export const getPaymentType = (type?: string, attributes?: { [index: string]: string }) => {

    if (type == "PLAYER_TRANSFER") {
        return t("transactions.types.player-transfer");
    } else if (type == "CASH_BONUS") {
        return t("transactions.types.cash-bonus");
    } else if (type == "BONUS") {
        return t("transactions.types.bonus");
    } else if (type == "CORRECTION") {
        return t("transactions.types.correction");
    } else if (type == "API") {
        if (attributes && attributes["USER_REFERENCE"]) {
            return attributes["USER_REFERENCE"];
        } else {
            return t("transactions.types.api");
        }
    } else {
        return "N/A";
    }
}




export const getAmountClass = (amount?: number, type?: PaymentType, status?: PaymentStatus) => {
    if (status === PaymentStatus.CANCELED || status === PaymentStatus.DECLINED) {
        return 'canceled';
    }
    if (type === PaymentType.WITHDRAWAL) {
        return 'negative';
    } else if (type === PaymentType.DEPOSIT) {
        return 'positive';
    }
    if (amount === 0) {
        return 'zero';
    }
    return amount && amount > 0 ? 'positive' : 'negative';
};


